import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CosingResponse } from '../models/cosingresponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CosingService {

constructor(private http:HttpClient) { }


search(model:CosingSearchRequest,page:number){

  const formData = new FormData();

  // JSON'u Blob olarak ekle
  const jsonBlob = new Blob([JSON.stringify(model)], { type: 'application/json' });

  // FormData'ya "query" adıyla ekle
  formData.append('query', jsonBlob, 'blob');

 return this.http.post<CosingResponse>("https://api.tech.ec.europa.eu/search-api/prod/rest/search?apiKey=285a77fd-1257-4271-8507-f0c6b2961203&text=*&pageSize=200&pageNumber="+page,formData)
}

addHammadde(model:any){
  return this.http.post(environment.apiUrl+"test",model);
  }

}




export class CosingSearchRequest {
  bool: Bool
}

export interface Bool {
  must: Must[]
}

export interface Must {
  text?: Text
  terms?: Terms
}

export interface Text {
  query: string
  fields: string[]
  defaultOperator: string
}

export interface Terms {
  itemType: string[]
}

